import { Tooltip, Typography } from "@mui/material"
import { TableRecordType } from "../../components/Table"

export const shownSkillsFormatter =
  (remainingSkillsField: string) => (record: TableRecordType, prop: string) => {
    const shownSkills = record[prop]
    const remainingSkills = record[remainingSkillsField]

    if (!remainingSkills) {
      return shownSkills
    }

    return (
      <Tooltip arrow title={remainingSkills}>
        <Typography variant="body2">{shownSkills}</Typography>
      </Tooltip>
    )
  }

export const reportingCategoriesAndStandardsFormatter = (
  record: TableRecordType,
  prop: string
) => {
  if (!record[prop] || record[prop] === "null") return "--"

  let itemsArray = []

  if (typeof record[prop] === "string") {
    itemsArray = (record[prop] as string)?.split(",")?.map(item => item.trim())
  }

  if (Array.isArray(record[prop])) {
    itemsArray = [...record[prop]]
  }

  const count = itemsArray?.length || 0

  if (count > 1) {
    return (
      <Tooltip arrow title={itemsArray.join(", ")}>
        <Typography variant="body2">{`${itemsArray[0]} + ${
          count - 1
        } more`}</Typography>
      </Tooltip>
    )
  }

  return <Typography variant="body2">{record[prop]}</Typography>
}
